import type { ReferralShareLocation } from 'common/events/ClientEvents';
import { create } from 'zustand';
import { createSelectors } from './create-selectors';

interface State {
  isWSSReferralAdModalShowing: boolean;
  analyticsLocation?: ReferralShareLocation;
}

interface Actions {
  showWSSReferralAdModal: (analyticsLocation: ReferralShareLocation) => void;
  hideWSSReferralAdModal: () => void;
}

const INITIAL_STATE = {
  isWSSReferralAdModalShowing: false,
  analyticsLocation: undefined,
};

export const useWSSReferralAdModalStore = create<State & Actions>((set) => ({
  ...INITIAL_STATE,
  showWSSReferralAdModal: (analyticsLocation) => set({ isWSSReferralAdModalShowing: true, analyticsLocation }),
  hideWSSReferralAdModal: () => set({ isWSSReferralAdModalShowing: false, analyticsLocation: undefined }),
}));

export const useWSSReferralAdModalStoreSelectors = createSelectors(useWSSReferralAdModalStore);
